// Imports
// React
import React from 'react';
// Components
import { EmailCaptureForm } from './EmailCaptureForm';
import { ThankYouMessage } from './ThankYouMessage';

interface ValidationHeroProps extends React.HTMLAttributes<HTMLDivElement> {
  onEmailSubmit: (email: string) => Promise<void>;
  isSubmitting?: boolean;
  submitError?: string | null;
  showThankYou?: boolean;
  className?: string;
}

// Component Definition
export const ValidationHero: React.FC<ValidationHeroProps> = ({
  onEmailSubmit,
  isSubmitting = false,
  submitError = null,
  showThankYou = false,
  className = '',
  ...props
}) => {
  return (
    <section
      className={`relative flex min-h-screen w-full flex-1 items-center justify-center overflow-hidden bg-white dark:bg-black ${className}`}
      {...props}
    >
      {/* Background image and overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?q=80&w=1000&auto=format&fit=crop"
          alt="Live music performance background"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black opacity-60 transition-opacity duration-200 dark:opacity-80"></div>
      </div>

      {/* Content above overlay */}
      <div className="relative z-10 flex w-full flex-col items-center justify-center px-6 py-12 sm:px-10 md:px-16">
        <div className="flex w-full max-w-3xl flex-col text-center font-sans text-white antialiased">
          {/* Headline - Problem-focused (Variant A: Venue-focused) */}
          <h1
            className="mb-6 text-4xl font-extrabold tracking-tight antialiased drop-shadow-lg sm:text-5xl md:text-6xl"
            style={{ lineHeight: '1.5' }}
          >
            Tired of texting 10 bands to fill Friday night?
          </h1>

          {/* Subheadline - Value proposition */}
          <p className="mb-10 text-xl font-medium leading-relaxed text-gray-100 antialiased drop-shadow-md sm:text-2xl">
            Stop playing phone tag. Find available musicians.
          </p>

          {/* Email capture form */}
          {!showThankYou ? (
            <div className="mx-auto w-full max-w-2xl">
              <EmailCaptureForm
                onSubmit={onEmailSubmit}
                isLoading={isSubmitting}
                error={submitError}
              />
            </div>
          ) : (
            <ThankYouMessage />
          )}
        </div>
      </div>
    </section>
  );
};
